import { FC, useEffect, useMemo } from "react";
import { ITransferListItem } from "@miplatform/types";
import { TransferList } from "@mibuildweb/components";
import { useDepartments } from "@mibuildweb/hooks";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { UserDetailsTabProps } from "../../ConfigUsers.types";

export const UserDepartmentsTabView: FC<UserDetailsTabProps> = ({
  form,
  extraTabProps: { isViewingDepartmentUser = false, isReadOnly = false } = {},
}) => {
  const { setValue } = form;
  const { departments: formDepartments = [] } = form.getValues();
  const { departments, getDepartments } = useDepartments();

  const availableDepartments: ITransferListItem[] = useMemo(() => {
    return departments.map((department) => ({
      key: department.id,
      title: department.name,
    }));
  }, [departments]);

  const selectedDepartments: ITransferListItem[] = formDepartments?.map(
    (department) => ({
      key: department.id,
      title: department.name || "",
    })
  );

  const handleAddItem = (key: string) => {
    const selectedDept = departments.find((d) => d.id === key);
    if (!selectedDept) {
      return;
    }
    const updatedDepartments = [...formDepartments, selectedDept];

    setValue("departments", updatedDepartments, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const handleRemoveItem = (key: string) => {
    const updatedDepartments = formDepartments.filter((d) => d.id !== key);
    setValue("departments", updatedDepartments, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  useEffect(() => {
    getDepartments();
  }, []);

  return (
    <ConfigAccordionHeader title="Departments">
      <TransferList
        availableItems={availableDepartments}
        selectedItems={selectedDepartments}
        availableTitle="Departments"
        selectedTitle="Selected Departments"
        onAddItem={handleAddItem}
        onRemoveItem={handleRemoveItem}
        disabled={isViewingDepartmentUser || isReadOnly}
      />
    </ConfigAccordionHeader>
  );
};
